import { CalendarDays, Shuffle, Zap, Info } from "lucide-react";
import { de, uk, enGB, pl, ru } from "date-fns/locale";
import { Calendar } from "../ui/calendar";
import { WINDOWS, windowRange } from "../../lib/bookingMessage";
import { OptionCard, StepError } from "./WizardBits";

const DF = { de, ua: uk, en: enGB, pl, ru };
const MODES = [["date", CalendarDays], ["flexible", Shuffle], ["earliest", Zap]];
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const WindowChips = ({ a, w }) => (
  <div>
    <div className="mb-3 text-[11px] tracking-[0.25em] uppercase text-zinc-500">{a.windowLabel}</div>
    <div role="radiogroup" aria-label={a.windowLabel} className="grid grid-cols-2 sm:grid-cols-5 gap-2">
      {[...WINDOWS, ""].map((k) => (
        <button key={k || "any"} type="button" role="radio" aria-checked={w.data.window === k} data-testid={`wizard-window-${k || "any"}`}
          onClick={() => w.set("window", k)}
          className={`px-3 py-2.5 border text-left transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-gold ${w.data.window === k ? "border-gold bg-gold/10" : "border-white/10 hover:border-white/30"}`}>
          <span className="block text-[14px] text-white">{k ? a.windows[k] : a.anyTime}</span>
          {k && <span className="block text-[12px] text-zinc-500 font-mono">{windowRange(k)}</span>}
        </button>
      ))}
    </div>
  </div>
);

export const StepAppointment = ({ c, w, lang }) => {
  const a = c.appointment;
  const tomorrow = new Date(); tomorrow.setHours(0, 0, 0, 0); tomorrow.setDate(tomorrow.getDate() + 1);
  const selected = w.data.date ? new Date(`${w.data.date}T12:00:00`) : undefined;
  return (
    <div className="space-y-6">
      <div role="radiogroup" aria-label={c.stepTitles[2]} className="grid sm:grid-cols-3 gap-3">
        {MODES.map(([k, Icon]) => (
          <OptionCard key={k} compact testid={`wizard-mode-${k}`} icon={Icon} selected={w.data.mode === k} onClick={() => w.set("mode", k)} title={a.modes[k].title} desc={a.modes[k].desc} />
        ))}
      </div>
      {w.data.mode === "date" && (
        <div className="border border-white/10 bg-black/30 inline-block" data-testid="wizard-calendar">
          <Calendar
            mode="single" weekStartsOn={1} locale={DF[lang] || de} selected={selected} defaultMonth={selected || tomorrow}
            disabled={{ before: tomorrow }} onSelect={(d) => w.set("date", d ? iso(d) : "")}
            classNames={{
              caption_label: "text-[14px] font-medium text-white capitalize",
              head_cell: "text-zinc-500 w-10 font-normal text-[12px]",
              day: "h-10 w-10 p-0 text-[14px] text-zinc-200 hover:bg-white/10 focus:outline-none focus-visible:ring-1 focus-visible:ring-gold",
              day_selected: "!bg-gold !text-black font-semibold",
              day_today: "text-gold",
              day_disabled: "!text-zinc-700 hover:bg-transparent",
              nav_button: "h-8 w-8 inline-flex items-center justify-center border border-white/15 text-zinc-300 hover:border-gold hover:text-gold",
            }}
          />
        </div>
      )}
      {w.data.mode !== "earliest" && <WindowChips a={a} w={w} />}
      <p data-testid="wizard-appointment-notice" className="flex items-start gap-3 text-[13px] text-zinc-400 leading-relaxed">
        <Info size={15} className="text-gold mt-0.5 shrink-0" /> {a.notice}
      </p>
      <StepError text={w.errors.date} testid="wizard-error-date" />
    </div>
  );
};
